<section class="page">
	<header class="page-header">
		<h2>Modifier une cartouche</h2>
	</header>
	<div *ngIf="success" class="success">{{ success }}</div>
	<div *ngIf="error" class="error">{{ error }}</div>
	<form class="panel" (ngSubmit)="update()">
		<label for="select-cartouche">Choisir la cartouche à modifier</label>
		<input matInput id="select-cartouche" type="text"
			[matAutocomplete]="autoCartouche"
			[(ngModel)]="cartoucheSearch"
			(ngModelChange)="onCartoucheSearchChange($event)"		(focus)="onCartoucheSearchChange(cartoucheSearch)"			name="cartoucheSearch"
			autocomplete="off" />
		<mat-autocomplete #autoCartouche="matAutocomplete" panelClass="cartouche-autocomplete-panel" [displayWith]="displayCartouche" (optionSelected)="onCartoucheSelected($event)">
			@for (cartouche of filteredCartouches; track cartouche.id) {
				<mat-option [value]="cartouche">{{ cartouche.nom }}</mat-option>
			}
		</mat-autocomplete>
		<div *ngIf="id">
			<label for="nom">Nom</label>
			<input id="nom" name="nom" [(ngModel)]="form.nom" maxlength="255" />
			<label for="lot_cartouche_id">Lot cartouche</label>
			<select id="lot_cartouche_id" name="lot_cartouche_id" [(ngModel)]="form.lot_cartouche_id">
				<option [ngValue]="undefined">Sélectionner un lot</option>
				<option *ngFor="let lot of lots" [ngValue]="lot.id">{{ lot.nom }}</option>
			</select>
			<label for="chimie_id">Chimie</label>
			<select id="chimie_id" name="chimie_id" [(ngModel)]="form.chimie_id">
				<option [ngValue]="undefined">Sélectionner une chimie</option>
				<option *ngFor="let chimie of chimies" [ngValue]="chimie.id">{{ chimie.nom }}</option>
			</select>
			<label>
				<input type="checkbox" [(ngModel)]="form.utilise" name="utilise" /> Utilisée ou réservée
			</label>
			<label>
				<input type="checkbox" [(ngModel)]="form.inutilisable" name="inutilisable" /> Inutilisable
			</label>
			<div class="actions">
				<button type="submit" [disabled]="loading">Enregistrer</button>
			</div>
		</div>
	</form>
</section>
